<span [ngClass]="classes">
  <ng-content></ng-content>
</span>
